exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1_3hSy8OEyTm8Smdr7RbEr{margin-top:70px;margin-bottom:60px;color:#333;text-align:center}@media screen and (max-width: 800px){._1_3hSy8OEyTm8Smdr7RbEr{margin-top:35px;margin-bottom:30px}}\n", ""]);

// Exports
exports.locals = {
	"Masthead": "_1_3hSy8OEyTm8Smdr7RbEr"
};